import React from 'react';
import range from 'lodash/range'
import PropTypes from 'prop-types';

const moreThanMaxSymbol = 'more';
const blankValue = 'blankValue';

/*
 * BBS DDD 2017-12-23 Switches between a dropdown and number input if mobile.
 * otherwise just show number input.
 *
 * This is a little convoluted.
 */
class NumberInputSelect extends React.Component {
  constructor(props) {
    super(props);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);
    this.state = { useInput: props.quantity > props.maxDropdownQuantity, quantity: props.quantity }
  }

  /*
   * When input changes, we receive the event from the input
   */
  onInputChange(e) {
    this.onQuantityChange(e.target.value);
  }

  /*
   * When the user moves away from the input, we receive the event from the input
   */
  onInputBlur(e) {
    const value = e.target.value;
    if (isNaN(value)) {
      // Don't notify if we don't have a number
      this.setState({ quantity: value });
    } else {
      this.onQuantityChange(+value);
    }
  }

  /*
   * When we want to notify the outside world we've changed, call this.
   */
  onQuantityChange(val) {
    if (isNaN(val)) return;
    this.props.onChange(+val);
  }

  /*
   * When the select input changes, call this with the new value selected by the user
   */
  onSelectChange(val) {
    if (val === blankValue) {
      return;
    }

    if (val === moreThanMaxSymbol) {
      this.setState({ useInput: true, quantity: this.props.maxDropdownQuantity + 1 });
      this.onQuantityChange(this.props.maxDropdownQuantity + 1);
    } else {
      this.onQuantityChange(val);
    }
  }

  render() {
    const isMoreThanMax = this.props.quantity > this.props.maxDropdownQuantity;
    const forceInputOnMobile = (isMoreThanMax || this.state.useInput);
    return (
      <span className={this.props.componentClassName}>
        <input
          className={forceInputOnMobile ? '' : 'hidden-xs'}
          min="0"
          onInput={this.onInputChange}
          onBlur={this.onInputBlur}
          type="number"
          defaultValue={isNaN(this.state.quantity) && this.state.quantity || this.props.quantity}
          style={{width: 100}}
        />
        <select
          className={forceInputOnMobile ? "hidden" : "hidden-md hidden-lg hidden-sm"}
          onChange={(e) => this.onSelectChange(e.target.value)}
          defaultValue={this.state.quantity}
        >

          {/* range is "up to not including max" so to show maxDropwdownQuantity in the
           select, add 1 to it to make end argument to range */}
          {range(1, this.props.maxDropdownQuantity + 1) 
            .map(
              (n) => (
                <option
                  key={n}
                  value={n}
                >{n}</option>))}

          <option
            key={moreThanMaxSymbol}
            value={moreThanMaxSymbol}
          >More</option>

          <option
            key={blankValue}
            value={blankValue}
          ></option>

          <option
            key={0}
            value='0'
          >0</option>

        </select >
        {this.props.onDelete &&
          <a
            className={'btn btn-danger item-delete' + (this.state.useInput ? '' : ' hidden-xs')}
            href=""
            onClick={(e) => { e.preventDefault(); this.props.onDelete(); }}
            style={{ marginLeft: 15 }}
          >
            <span className="fa fa-regular fa-xmark"></span>
          </a>
        }

      </span>
    )
  }
}

NumberInputSelect.propTypes = {
  quantity: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  componentClassName: PropTypes.string,
  maxDropdownQuantity: PropTypes.number.isRequired
}

export default NumberInputSelect